import { OperationStatus } from '../../entities/operationStatus'
import { StandOperationResult } from '../../entities/standOperationResult'
import { SwitchStatus } from '../../entities/switchStatus'
import { TagId } from '../../entities/tagId'
import { Crc32AuthCommand, Crc32AuthResultFrame } from './crc32AuthTypes'

export class Crc32AuthOperationResultAdapter {
  convert(frame: Crc32AuthResultFrame): StandOperationResult {
    return {
      outcome: mapOutcome(frame.resultCode),
      area1TagId: toTagId(frame.area1CardNumber),
      area2TagId: toTagId(frame.area2CardNumber),
      selectedTagId: selectTagId(frame),
      switchStatus: mapSwitchStatus(frame),
      isIntermediateRead: false,
      firmwareVersion: frame.firmwareVersion.toString(16).padStart(2, '0'),
      telemetry: {
        batteryLevel: frame.batteryLevel,
        remainingUmbrellaCount: frame.remainingUmbrellaCount,
        failureFlag: frame.failureFlag,
      },
      rawResponseHex: frame.rawData.map((v) => v.toString(16).padStart(2, '0')),
    }
  }
}

function mapOutcome(resultCode: number): OperationStatus {
  switch (resultCode) {
    case 0:
      return 'fullyRead'
    case 1:
      return 'failed'
    case 2:
      return 'partialReadArea1'
    case 3:
      return 'partialReadArea2'
    case 4:
      return 'switchAcceptedNoReads'
    case 5:
      return 'switchAcceptedWithArea1'
    default:
      return 'failed'
  }
}

function mapSwitchStatus(frame: Crc32AuthResultFrame): SwitchStatus {
  const bits = frame.switchStatus
  const area1Pressed = (bits & 0x01) !== 0
  const area2Pressed = (bits & 0x02) !== 0

  // V1.4 spec: 返却 (0x8F) では area1/area2 と switch1/switch2 が入れ替わる。
  // legacy SwitchStatus は物理位置固定 semantics なので、返却時のみ bit0<->bit1 を入れ替えて正規化する。
  const isReturn = frame.commandCode === Crc32AuthCommand.returnResponse
  const pressedFirst = isReturn ? area2Pressed : area1Pressed
  const pressedSecond = isReturn ? area1Pressed : area2Pressed

  if (pressedFirst && pressedSecond) return 'pressedBoth'
  if (pressedFirst) return 'pressedFirst'
  if (pressedSecond) return 'pressedSecond'
  return 'notPressedBoth'
}

function selectTagId(frame: Crc32AuthResultFrame): TagId | null {
  switch (frame.resultCode) {
    case 0:
    case 2:
    case 5:
      return toTagId(frame.area1CardNumber)
    case 3:
      return toTagId(frame.area2CardNumber)
    case 1:
    case 4:
    default:
      return null
  }
}

function toTagId(cardNumber: number[] | null): TagId | null {
  if (cardNumber === null) return null
  return new TagId(
    cardNumber.map((b) => b.toString(16).padStart(2, '0')).join('')
  )
}
